












/* eslint-disable @typescript-eslint/camelcase */
import {
  getCarteChronologyListing,
  getCarteChronologyListing_getCarteChronologyListing_edges
} from "../graphql/types/getCarteChronologyListing";

import AppTextModule from "../store/modules/appTextModule";
import { Component } from "vue-property-decorator";
import QueryChronology from "../graphql/queryChronology";
import VideoPlayer from "../components/VideoPlayer.vue";
import ViewBase from "../views/ViewBase";
import { getCarteChronologyListingVariables } from "../graphql/types/getCarteChronologyListing";
import { getModule } from "vuex-module-decorators";

const appTextStore = getModule(AppTextModule);

@Component({
  apollo: {
    edges: {
      query: QueryChronology.getCarteChronologyListing,
      variables(): getCarteChronologyListingVariables {
        return {
          language: `${this.language}`
        };
      },
      update(data: getCarteChronologyListing) {
        // The returned value will update
        // the vue property 'edges'
        const result = data?.getCarteChronologyListing?.edges;
        return result;
      },
      fetchPolicy: "cache-and-network",
      error(error) {
        this.onError(error);
      }
    }
  },
  components: { VideoPlayer }
})
export default class Chronology extends ViewBase {
  private edges?: getCarteChronologyListing_getCarteChronologyListing_edges[];

  protected get title() {
    return appTextStore.appTextByKey("text.chronology");
  }

  private get fullpath() {
    let result = "";

    if (this?.edges) {
      if (this.edges.length === 1) {
        if (this.edges[0].node?.video?.fullpath) {
          result = `${this.uri}${this.edges[0].node.video.fullpath}`;
        }
      } else {
        this.onError("exactly 1 chronology object is expected.");
      }
    }

    return result;
  }
}
